import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
moment.locale('pt-BR');

@Pipe({
  name: 'convertToDateMoment'
})
export class ConvertToDateJsPipe implements PipeTransform {
  // args[0] -> Formato de entrada da String Date, args[1] -> Como deve ser a saída. ex: DD/MM/YYYY -> DD/MM
  transform(value: any, args?: any): any {
    if (typeof args === undefined) {
      console.error('Informe os argumentos do formato da data');
      return '';
    }
    if(!value || value.length < args[0].length) return "";

    return moment(value, args[0]).format(args[1]);
  }

}
